module.exports = __webpack_public_path__ + "static/media/Hospitalslide1.9c2c63f5.webp";